import React from 'react';
import { PropertyDetailsLink } from 'src/pages/NewBillingModule/ApplyBillingFull/AppfolioPush';
import { NO_GL_ACCOUNT } from '../apGlAccounts';
import { DASH } from './billDetailsUtils';
import useStyles from './billDetailsStyles';

/**
 * An Accounts Payable GL account as the bill details show it, and where there is none, the way to set one:
 * a link to the property's Details tab, which holds the default and each utility's own (LB-5981).
 * Opened in a new tab, so the bill and anything typed into it stay where they are.
 */
export function ApGlAccountValue(_ref) {
  let label = _ref.label,
    _ref$propertyLivableI = _ref.propertyLivableId,
    propertyLivableId = _ref$propertyLivableI === void 0 ? null : _ref$propertyLivableI;
  const classes = useStyles();
  if (!label) return DASH;
  if (label !== NO_GL_ACCOUNT || !propertyLivableId) return label;
  return /*#__PURE__*/React.createElement(React.Fragment, null, label, ' ', /*#__PURE__*/React.createElement(PropertyDetailsLink, {
    className: classes.glSetupLink,
    propertyLivableId: propertyLivableId
  }, "Set it up"));
}